import { render, staticRenderFns } from "./RawMaterialOnHoldInventories.vue?vue&type=template&id=42294cbe&scoped=true&"
import script from "./RawMaterialOnHoldInventories.vue?vue&type=script&lang=js&"
export * from "./RawMaterialOnHoldInventories.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialOnHoldInventories.vue?vue&type=style&index=0&id=42294cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42294cbe",
  null
  
)

export default component.exports